import { render, staticRenderFns } from "./RolesFilter.vue?vue&type=template&id=7233d319&scoped=true&"
import script from "./RolesFilter.vue?vue&type=script&lang=js&"
export * from "./RolesFilter.vue?vue&type=script&lang=js&"
import style0 from "./RolesFilter.vue?vue&type=style&index=0&id=7233d319&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7233d319",
  null
  
)

export default component.exports